import { auth } from '../firebase';

interface QuickReply {
  id: string;
  text: string;
  icon?: string;
}

const getAdminAuthorizationHeader = async (): Promise<Record<string, string>> => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error('Sessione amministratore non disponibile');
  return { Authorization: `Bearer ${token}` };
};

/**
 * Genera quick replies automaticamente usando endpoint server-side.
 */
export const generateQuickReplies = async (
  title: string,
  location: string,
  description: string
): Promise<QuickReply[]> => {
  try {
    console.log('🤖 Generazione quick replies via API server...');

    const response = await fetch('/api/generate-quick-replies', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await getAdminAuthorizationHeader()),
      },
      body: JSON.stringify({
        title,
        location,
        description,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.warn('⚠️ API quick replies non disponibile:', errorText);
      return getDefaultQuickReplies();
    }

    const result = await response.json();
    const quickReplies = result?.quickReplies;

    if (!Array.isArray(quickReplies) || quickReplies.length === 0) {
      return getDefaultQuickReplies();
    }

    return quickReplies.slice(0, 6);
  } catch (error) {
    console.error('❌ Errore nella generazione quick replies:', error);
    return getDefaultQuickReplies();
  }
};

/**
 * Quick replies di default in caso di errore
 */
const getDefaultQuickReplies = (): QuickReply[] => [
  {
    id: 'qr-1',
    text: '📚 Raccontami la storia di questo luogo',
    icon: 'book'
  },
  {
    id: 'qr-2',
    text: '👀 Cosa posso visitare qui',
    icon: 'eye'
  },
  {
    id: 'qr-3',
    text: '🍝 Quali sono i piatti tipici',
    icon: 'restaurant'
  },
  {
    id: 'qr-4',
    text: '✨ Ci sono leggende locali',
    icon: 'sparkles'
  },
  {
    id: 'qr-5',
    text: '📅 Quando visitare',
    icon: 'calendar'
  },
  {
    id: 'qr-6',
    text: '🎭 Eventi e tradizioni',
    icon: 'calendar-star'
  }
];
